import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PageHeader from "../../Elements/Header";
import RegistrationForm from "../../Elements/Registration";

const EventContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
  padding: 2rem;
  background-color: #f7f9fc;
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  width: 300px;
  height: 450px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  img {
    width: 100%;
    height: 180px;
    object-fit: cover;
  }

  .card-content {
    padding: 0.5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  h2 {
    font-size: 1.2rem;
    color: #2d3748;
    margin: 0.25rem 0;
    text-align: center;
  }

  p {
    font-size: 0.9rem;
    color: #718096;
    margin: 0.25rem 0;
    text-align: center;
  }

  .date {
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 0.5rem;
    margin: 0.25rem 0;
    border-radius: 5px;
    font-size: 0.8rem;
    text-align: center;
  }

  .event-id {
    background: #e2e8f0;
    color: #2d3748;
    padding: 0.5rem;
    margin: 0.25rem 0;
    border-radius: 5px;
    font-size: 0.8rem;
    text-align: center;
  }

  button {
    background: #ff5757;
    color: white;
    padding: 0.6rem 1rem;
    border: none;
    border-radius: 5px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background 0.3s ease;
    align-self: center;
    margin-top: 1rem;

    &:hover {
      background: #e04b4b;
    }
  }
`;
const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem; /* Prevents content from touching edges */
`;
const ModalContent = styled.div`
  position: relative; /* Make this relative to position the close button */
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  width: 90%;
  max-width: 500px;
  max-height: 90vh; /* Prevents the modal from being too tall */
  overflow-y: auto; /* Enables scrolling if needed */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  text-align: left;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */

  h2 {
    margin-bottom: 0.51rem;
    color: #2d3748;
    font-size: 1rem; /* Adjust font size */
    font-weight: 700; /* Make it bold */
    line-height: 1; /* Adjust line height for better spacing */
    text-transform: uppercase; /* Add uppercase for emphasis */
    letter-spacing: 0.02em; /* Slight spacing between letters */
  }

  .button-container {
    margin-top: 2.0rem;
    display: flex;
    justify-content: center;
    gap: 1rem;

    .close-btn {
      background: #e2e8f0;
      color: #2d3748;
      padding: 0.6rem 1rem;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      transition: background 0.3s ease;

      &:hover {
        background: #cbd5e0;
      }
    }
  }

.top-close-btn {
  position: absolute; /* Place it in the top-right corner */
  top: 10px; /* Adjust as needed */
  right: 10px; /* Adjust as needed */
  background:rgb(62, 154, 229); /* Red background */
  color: white;
  height: 50px;
  width: 50px;
  border: none;
  border-radius: 50%; /* Circular button */
  display: flex; /* Center the content */
  align-items: center;
  justify-content: center;
  font-size: 1.5rem; /* Adjust the size of the "X" */
  cursor: pointer;
  transition: background 0.3s ease;
   font-weight: 700; 

  &:hover {
    background:rgb(197, 65, 48); /* Darker red on hover */
  }
}
`;
function EventCards() {
  const [events, setEvents] = useState([]);
  const [activeEvent, setActiveEvent] = useState(null); // Tracks the currently selected event

  useEffect(() => {
    fetch("https://pristineacademicconsultancy.com/Admin/Fetch_events.php")
      .then((response) => response.json())
      .then((data) => setEvents(data))
      .catch((error) => console.error("Error fetching events:", error));
  }, []);

  const handleRegisterClick = (event) => {
    setActiveEvent(event); // Set the selected event
  };

  const closeModal = () => {
    setActiveEvent(null); // Close the modal
  };

  return (
    <>
      <PageHeader
        title="Upcoming Webinar Events"
        subtitle="With Pristine"
        description="Join us for exciting and informative webinars. Stay updated and be part of insightful discussions."
        buttonText="Register Now"
        buttonAction={() => (window.location.href = "/events")} // Replace with your desired URL
        backgroundImage="images/education.jpg"
      />

      <EventContainer>
        {events.length > 0 ? (
          events.map((event, index) => (
            <Card key={index}>
              <img src={event.img} alt={event.title} />
              <div className="card-content">
                <h2>{event.title}</h2>
                {/* Show Event ID */}
                {/* <div className="event-id">Event ID: {event.id}</div> This line displays the event ID */}
                <p>{event.description}</p>
                <div className="date">
                  {event.date} <br /> {event.time}
                </div>
                <button onClick={() => handleRegisterClick(event)}>
                  REGISTER NOW
                </button>
              </div>
            </Card>
          ))
        ) : (
          <p>No events available at the moment.</p>
        )}
      </EventContainer>

      {/* Modal for Registration */}
      {activeEvent && (
        <Modal>
          <ModalContent>
            <button className="top-close-btn" onClick={closeModal}>
              &times;
            </button>
            <h2>Register for {activeEvent.title}</h2>
            <RegistrationForm eventId={activeEvent.id} />
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

export default EventCards;
